/**
 * Fase A: export PLU → archivo para iTegra (Kretz) / Qendra (Systel).
 * Brand = preset alias; no forks de código por marca.
 */

export type LabelScaleAdapterId = 'kretz_report_file' | 'systel_csv';

export type LabelScaleExportRow = {
  plu: string;
  name: string;
  price: number;
  /** P = pesable, N = unidad */
  type: 'P' | 'N';
  department?: string;
};

export const LABEL_SCALE_ADAPTERS: Array<{
  id: LabelScaleAdapterId;
  label: string;
  brandAliases: string[];
  filename: string;
}> = [
  {
    id: 'systel_csv',
    label: 'CSV Systel / Qendra',
    brandAliases: ['Systel', 'Qendra'],
    filename: 'vuelto-plu-systel.csv',
  },
  {
    id: 'kretz_report_file',
    label: 'Archivo Kretz / iTegra',
    brandAliases: ['Kretz', 'iTegra'],
    filename: 'vuelto-plu-kretz.csv',
  },
];

function escapeCsvCell(value: string, sep: string): string {
  const needsQuote = value.includes(sep) || value.includes('"') || value.includes('\n');
  const escaped = value.replace(/"/g, '""');
  return needsQuote ? `"${escaped}"` : escaped;
}

function money(n: number): string {
  return n.toFixed(2);
}

/** CSV estilo Qendra (Systel): columnas mínimas para import PLU. */
export function buildSystelCsv(rows: LabelScaleExportRow[]): string {
  const sep = ';';
  const header = [
    'Sección',
    'Código PLU',
    'Descripción',
    'Número PLU',
    'Precio1',
    'Precio2',
    'Tipo',
    'Vencimiento',
  ].join(sep);
  const body = rows.map((r) =>
    [
      escapeCsvCell(r.department ?? '1', sep),
      escapeCsvCell(r.plu, sep),
      escapeCsvCell(r.name, sep),
      escapeCsvCell(r.plu, sep),
      money(r.price),
      money(r.price),
      r.type,
      '0',
    ].join(sep),
  );
  return [header, ...body].join('\n');
}

/** Archivo report-like para iTegra (Kretz): CSV con ; y tipo P/N. */
export function buildKretzReportFile(rows: LabelScaleExportRow[]): string {
  const sep = ';';
  const header = [
    'PLU',
    'Codigo',
    'Nombre',
    'Departamento',
    'Precio',
    'Tipo',
    'Etiqueta',
  ].join(sep);
  const body = rows.map((r) =>
    [
      escapeCsvCell(r.plu, sep),
      escapeCsvCell(r.plu, sep),
      escapeCsvCell(r.name.slice(0, 40), sep),
      escapeCsvCell(r.department ?? '1', sep),
      money(r.price),
      r.type,
      '1',
    ].join(sep),
  );
  return [header, ...body].join('\n');
}

export function buildLabelScaleExportFile(
  adapterId: LabelScaleAdapterId,
  rows: LabelScaleExportRow[],
): { content: string; filename: string } {
  const meta = LABEL_SCALE_ADAPTERS.find((a) => a.id === adapterId) ?? LABEL_SCALE_ADAPTERS[0];
  const content =
    adapterId === 'kretz_report_file' ? buildKretzReportFile(rows) : buildSystelCsv(rows);
  return { content, filename: meta.filename };
}
